import { FunctionComponent, ReactNode } from 'react';
import { Card } from '@mui/material';
import { Button } from '../button';
import { ReactComponent as DocumentWarningImage } from '../../../assets/images/document-warning.svg';
import { ReactComponent as DocumentCheckedImage } from '../../../assets/images/document-checked.svg';
import { ReactComponent as MoneyCheckImage } from '../../../assets/icons/money-check.svg';
import { ReactComponent as CheckBlueLargeImage } from '../../../assets/icons/check-blue-large.svg';
import { ReactComponent as DeleteTrashLargeImage } from '../../../assets/icons/delete-trash-large.svg';
import { ReactComponent as CheckmarkSuccessLargeImage } from '../../../assets/icons/checkmark-success-large.svg';

import './styles.scss';

export type CardConfirmLevel = 'warning' | 'error' | 'success' | 'info' | 'checked' | 'delete' | 'delete-success' | 'change-owner';

interface CardConfirmProps {
  onClose: (confirm: boolean) => void;
  level: CardConfirmLevel;
  headline: ReactNode;
  description: ReactNode;
  cancelChildren?: ReactNode;
  confirmChildren: ReactNode;
  customIcon?: ReactNode;
}

const CardConfirm: FunctionComponent<CardConfirmProps> = ({
  onClose,
  level,
  headline,
  description,
  cancelChildren,
  confirmChildren,
  customIcon,
}) => (
  <Card classes={{ root: `card_confirm__card ${level}` }} elevation={0}>
    {customIcon ? (
      customIcon
    ) : level === 'success' ? (
      <DocumentCheckedImage />
    ) : level === 'info' ? (
      <MoneyCheckImage />
    ) : level === 'checked' ? (
      <CheckBlueLargeImage />
    ) : level === 'delete' ? (
      <DeleteTrashLargeImage />
    ) : level === 'delete-success' ? (
      <CheckmarkSuccessLargeImage />
    ) : (
      <DocumentWarningImage />
    )}
    <div>{headline}</div>
    <div dangerouslySetInnerHTML={typeof description === 'string' ? { __html: description } : undefined}>
      {typeof description !== 'string' ? description : null}
    </div>
    <div className="card_confirm__card__button">
      {cancelChildren && (
        <Button variant="outlined" onClick={() => onClose(false)}>
          {cancelChildren}
        </Button>
      )}
      <Button onClick={() => onClose(true)}>{confirmChildren}</Button>
    </div>
  </Card>
);

export default CardConfirm;
